module.exports = __webpack_public_path__ + "static/media/75.6b2e66b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/75.wav
// module id = MQgm
// module chunks = 0